export class Passenger {
  email: string;
  phonenumber: string;
  firstname: string;
  lastname: string;
  arrivalTime: string;
  departureTime: Date;
  terminal: number;
  persons: number;
  regNumber: string;
  parkingSpot: string;
  parkingStart: Date;
  parkingEnd: Date;
  hasBaggage: boolean;
  hasLanded: boolean;
  flightNumber: string;
  extra: string;
  code: string;
  status: string;
}

export class Arrivals {
  flights: any;
  numberOfFlights: number;
  to: any;
}

export class Departures {}

export class TravelTimeMaker {
  static create(event: TravelTime) {
    return {flight : event.flight, parkingStart: event.parkingStart};
  }
}
export class TravelTime {
  flight: Flightinfo;
  parkingStart?: Date;
}

export interface Flightinfo {
  airlineOperator: AirlineOperator;
  arrivalAirportEnglish: string;
  arrivalAirportSwedish: string;
  arrivalTime: ArrivalTime;
  baggage: boolean;
  checkIn: CheckIn;
  codeShareData: string[];
  departureAirportEnglish: string;
  departureAirportSwedish: string;
  departureTime: DepartureTime;
  diIndicator: string;
  flightId: string;
  flightLegIdentifier: FlightLegIdentifier;
  locationAndStatus: LocationAndStatus;
  remarksEnglish: string[];
  remarksSwedish: string[];
  viaDestinations: [];
}

export interface AirlineOperator {
  iata: string;
  icao: string;
  name: string;
}

export interface DepartureTime {
  actual: string;
  scheduled: string;
  estimated: string;
}

export interface ArrivalTime {
  actual: string;
  scheduled: string;
  estimated: string;
}

export interface FlightLegIdentifier {
  callsign: string;
  flightId: string;
  flightDepartureDateUtc: string;
}

export interface LocationAndStatus {
  terminal: string;
  flightLegStatus: string;
  flightLegStatusSwedish: string;
}

export interface CheckIn {
  checkInStatus: string;
  checkInDeskFrom: number;
  CheckInStatusEnglish: string;
  CheckInDeskFrom: number;
  CheckInDeskTo: number;
}
